module.exports = __webpack_public_path__ + "img/SKMJ_work2.76968ccd.png";